import type { BreadcrumbConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Offering } from "@/lib/types/database/offerings";

export const offeringDetailBreadcrumbs: BreadcrumbConfig = {
  show: true,
  items: [
    {
      label: "Offerings",
      href: "/offerings",
    },
    {
      label: "Offering Details",
      href: (item: unknown) => `/offerings/${(item as Offering).id}`,
      current: true,
    },
  ],
};
